import { AnimatePresence } from "framer-motion";
import MessengerCustomerChat from "react-messenger-customer-chat";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Footer from "./components/Shared/Footer/Footer";
import Header from "./components/Shared/Header/Header";
import Collaboration from "./pages/Collaboration";
import Home from "./pages/Home/Home";
import Impact from "./pages/Impact/Impact";
import NotFound from "./pages/NotFound";
import Resource from "./pages/Resource/Resource";
import Team from "./pages/Team";

function App() {
  return (
    <Router>
      <Header />
      <AnimatePresence>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/impact" exact component={Impact} />
          <Route path="/team" exact component={Team} />
          <Route path="/collaboration" exact component={Collaboration} />
          <Route path="/resource" exact component={Resource} />
          <Route path="*" component={NotFound} />
        </Switch>
      </AnimatePresence>
      <MessengerCustomerChat pageId="127078185474063" appId="386660386396121" />
      <Footer />
    </Router>
  );
}

export default App;
